<template>
  <v-dialog v-model="show" :max-width="600" :fullscreen="$vuetify.breakpoint.xsOnly" transition="dialog-bottom-transition" scrollable>
    <v-card :class="{ 'rounded-xl': !$vuetify.breakpoint.xsOnly }" elevation="10" class="d-flex flex-column">
      <v-card-title class="pa-4 primary white--text d-flex justify-space-between align-center">
        <span class="text-h6 font-weight-bold">Actualizar distribuidor</span>
        <v-btn icon dark @click="show = false" v-if="$vuetify.breakpoint.xsOnly">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-6 bg-app">
        <v-container>
          <v-form ref="updateDistributor">
            <v-row>
              <v-col cols="12" class="pb-0">
                <span class="text-subtitle-1 font-weight-bold primary--text">Datos generales</span>
              </v-col>
              <v-col cols="12" sm="6" class="pb-0">
                <v-text-field
                  outlined
                  dense
                  label="Nombre distribuidor"
                  :rules="validation()"
                  v-model="name"
                  class="white rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" class="pb-0">
                <v-text-field
                  outlined
                  dense
                  label="Teléfono"
                  type="number"
                  :rules="validationPhone()"
                  v-model="phone"
                  class="white rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pb-0">
                <v-text-field
                  outlined
                  dense
                  label="Correo"
                  :rules="validationEmail()"
                  v-model="email"
                  class="white rounded-lg"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  outlined
                  dense
                  label="Seleccionar laboratorio asociado(s)"
                  :items="laboratories"
                  :rules="[(v) => v.length > 0 || `El campo es obligatorio.`]"
                  item-text="name"
                  v-model="laboratoriesSelected"
                  multiple
                  chips
                  small-chips
                  hide-no-data
                  return-object
                  clearable
                  class="white rounded-lg"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-4 bg-white">
        <v-spacer></v-spacer>
        <v-btn
          color="grey"
          text
          @click="show = false"
          :disabled="isLoading"
          class="px-4"
        >
          Cancelar
        </v-btn>
        <v-btn color="primary" rounded @click="update" :loading="isLoading" elevation="0" class="px-8">
          Actualizar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//Vuex
import { mapActions, mapState, mapMutations } from "vuex";
//validation
import {
  requiredValidation,
  requiredValidationPassword,
  phoneValidation,
  emailValidation,
} from "@/helpers/validations.js";
export default {
  data: () => ({
    isLoading: false,
    email: null,
    name: null,
    phone: null,
    laboratories: [],
    laboratoriesSelected: [],
    emailValidations: emailValidation(),
  }),
  props: {
    value: Boolean,
  },
  computed: {
    ...mapState("user", ["distributorSelected"]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapActions("laboratory", ["getLaboratories"]),
    ...mapActions("organization", ["updateDistributor"]),
    validation(name) {
      return requiredValidation(name);
    },
    validationPassword(name) {
      return requiredValidationPassword(name);
    },
    validationPhone(name) {
      return phoneValidation(name);
    },
    validationEmail(name) {
      return this.emailValidations;
    },
    async update() {
      try {
        if (this.$refs.updateDistributor.validate()) {
          this.isLoading = true;
          let labsId = [];
          for (let item of this.laboratoriesSelected) {
            labsId.push(item._id);
          }
          let payload = {
            distributorId: this.distributorSelected._id,
            organization: {
              email: this.email,
              companyName: this.name,
              phone: this.phone,
              laboratories: labsId,
            },
          };

          let response = await this.updateDistributor(payload);
          if (!response) throw response;
          this.$emit("fetchData");
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: "Distribuidor actualizado",
            timeout: 5000,
          });

          this.show = false;
        }
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal al crear usuario",
          timeout: 5000,
        });
      }
      this.isLoading = false;
    },
    async setLaboratories() {
      try {
        let response = await this.getLaboratories();
        if (!response) throw response;
        this.laboratories = response.laboratories;
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal al cargar laboratorios",
          timeout: 5000,
        });
      }
    },
    async setDistributor() {
      this.name = this.distributorSelected.companyName;
      this.email = this.distributorSelected.email;
      this.phone = this.distributorSelected.phone;
      let labIds = [];
      for (let lab of this.distributorSelected.laboratories) {
        labIds.push(lab._id);
      }
      console.log(labIds);
      this.laboratoriesSelected = this.laboratories.filter((element) =>
        labIds.includes(element._id)
      );
    },
  },
  async created() {
    await this.setLaboratories();
    await this.setDistributor();
  },
};
</script>
